import React, { useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
// import Spinner from "react-bootstrap/Spinner";
import PrintEwayBill from "./PrintEwayBill";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";

//Redux
import { useDispatch } from "react-redux";

//API
import DataTable from "react-data-table-component";
// import { formatNumber } from "../../../../common/Validations";
// import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
// import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../../common/Validations";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { useReactToPrint } from "react-to-print";

const EwayBillConfirmationModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [disable, setDisabled] = useState(false);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  // eslint-disable-next-line no-unused-vars
  const [viewInvoiceDataStatus, setViewInvoiceDataStatus] = useState(false);
  const [lineItemData, setLineItemData] = useState([]);
  const [invoiceData, setInvoiceData] = useState();
  const [ewabilldata, setEwabilldata] = useState();

  const diableEwaybill = invoiceData?.e_WayBillNo;

  //print
  useEffect(() => {
    setPrintInvoiceData(props?.ewaybill);
  }, [props?.ewaybill]);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `LoadingAdvice_${Math.floor(Math.random() * 1000000)}`,
  });

  // ewayBill
  // eslint-disable-next-line no-unused-vars
  const [getDropdownData, setDropdownData] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [totals, setTotals] = useState({
    totalBags: 0,
    totalAmount: 0,
    totalCgst: 0,
    totalSgst: 0,
    totalNetValue: 0,
  });
  // console.log(">>totals", totals);
  // const [disable, setDisabled] = useState(false);

  //send print data
  const [printInvoiceData, setPrintInvoiceData] = useState();

  // eslint-disable-next-line no-unused-vars
  let dropdownOption = [
    {
      id: "1",
      name: "30 Days",
    },
    {
      id: "2",
      name: "60 Days",
    },
    {
      id: "3",
      name: "90 Days",
    },
  ];

  const lineItemCol = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.orderQtyLoadConfirm} </p>
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "130px",
    },

    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => <span>{row?.cgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => <span>{row?.sgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    // {
    //   name: "Net Value",
    //   selector: (row) => row?.netValue || "--",
    //   cell: (row) => <span>{row?.netValue} </span>,

    //   sortable: true,
    //   width: "120px",
    // },

    {
      name: "CGST%",
      selector: (row) => row?.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst || "--",
      sortable: true,
      width: "100px",
    },
    // {
    //   name: "Driver",
    //   selector: (row) => row?.netValue || "--",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row?.transporterDriverName} </p>
    //       <p className="m-0 p-0 ">{row?.transporterDriverContact} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Truck No",
    //   selector: (row) => row?.netValue || "--",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingTruckNo} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
  ];

  useEffect(() => {
    setInvoiceData((invoiceData) => ({
      ...invoiceData,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
  }, [getDropdownData]);

  useEffect(() => {
    if (props?.ewaybill) {
      const updatedLineItems = props.ewaybill.items.map((item) => {
        const orderQuantityLoad = parseFloat(item.orderQtyLoadConfirm) || 0;
        const unitPrice = parseFloat(item.unitPrice) || 0;
        const reversePercentage = parseFloat(item.reversePercentage) || 1; // Avoid division by zero
        const cgst = parseFloat(item.cgst) || 0;
        const sgst = parseFloat(item.sgst) || 0;
        const gst = cgst + sgst;

        // Basic Price Calculation
        const basicPrice = (unitPrice / reversePercentage).toFixed(2);

        // Basic Amount Calculation
        const basicAmount = (basicPrice * orderQuantityLoad).toFixed(2);

        // Rate Calculation
        const rate = (orderQuantityLoad * unitPrice).toFixed(2);

        // CGST & SGST Calculation
        const cgstValue = ((cgst * basicAmount) / 100).toFixed(2);
        const sgstValue = ((sgst * basicAmount) / 100).toFixed(2);

        // GST Calculation
        const gstValue = ((gst * basicAmount) / 100).toFixed(2);

        // Net Value Calculation
        const netValue = (
          parseFloat(gstValue) + parseFloat(basicAmount)
        ).toFixed(2);

        return {
          ...item,
          basicPrice,
          basicAmount,
          rate,
          cgstValue,
          sgstValue,
          gstValue,
          netValue,
          gst, // Updating gst to sum of cgst + sgst
        };
      });

      setLineItemData(updatedLineItems);

      // Calculate Totals
      const totalBags = updatedLineItems.reduce(
        (sum, item) => sum + parseFloat(item.orderQtyLoadConfirm || 0),
        0
      );
      const totalAmount = updatedLineItems.reduce(
        (sum, item) => sum + parseFloat(item.basicAmount || 0),
        0
      );
      const totalCgst = updatedLineItems.reduce(
        (sum, item) => sum + parseFloat(item.cgstValue || 0),
        0
      );
      const totalSgst = updatedLineItems.reduce(
        (sum, item) => sum + parseFloat(item.sgstValue || 0),
        0
      );
      const totalNetValue = updatedLineItems.reduce(
        (sum, item) => sum + parseFloat(item.netValue || 0),
        0
      );

      const calculatedTotals = {
        totalBags,
        totalAmount: totalAmount.toFixed(2),
        totalCgst: totalCgst.toFixed(2),
        totalSgst: totalSgst.toFixed(2),
        totalNetValue: totalNetValue.toFixed(2),
      };

      setTotals(calculatedTotals);

      // Update invoiceData with totals
      setInvoiceData({
        ...props.ewaybill, // Preserve existing fields
        items: updatedLineItems,
        totals: calculatedTotals,
      });
    }
  }, [props?.ewaybill]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
  };

  const onInputChange = ({ target: { name, value } }) => {
    // setInvoiceData((invoiceData) => ({ ...invoiceData, [name]: value }));
    setEwabilldata((ewabilldata) => ({ ...ewabilldata, [name]: value }));
  };
  const handleSave = async () => {
    // console.log(">>invoiceData", invoiceData);

    const obj = {
      ...ewabilldata,
      ewayBill: invoiceData.ewayBill,
      invoiceNr: invoiceData.invoiceNr,
      loadingAdviceNr: invoiceData.documentNumber,
      generatedDate: invoiceData.generatedDate || getTodaysData(),
    };

    // console.log(">>obj", obj);
    setDisabled(true);
    await ItemServiceV2.updateEwayBill(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  // const documentTypeMap = {
  //   "101 - GST Registration": "GST",
  //   "100 - PAN Registration": "PAN",
  //   "131 - GST Registration": "GST",
  // };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getLoadingAdviceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getOrderSchedulingList(obj));
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          E-Way Bill - {invoiceData?.orderSchedulingNr}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={8} lg={8}>
                  <span className="headerTitle">E-Way Bill details</span>
                  <span className="subHeaderTitle">E-Way Bill details</span>
                </Col>
                {!!diableEwaybill && (
                  <Col xs={4} md={2} lg={2}>
                    <button className="btnTable" onClick={handlePrint}>
                      {" "}
                      <i class="bi bi-printer"></i> Print E-Way Bill
                    </button>
                    <div style={{ display: "none" }}>
                      <PrintEwayBill ref={contentRef} data={printInvoiceData} />
                    </div>
                  </Col>
                )}
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  
                  {/* <Col xs={12} md={12} lg={12}>
                   <div style={{ display: "block" }}>
                      <PrintEwayBill ref={contentRef} data={printInvoiceData} />
                    </div>
                  </Col> */}
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        {!!diableEwaybill && (
                          <Row>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="E-WayBill Nr"
                                name="e_WayBillNo"
                                id="e_WayBillNo"
                                value={invoiceData?.e_WayBillNo}
                                // onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="E-Way Bill Status"
                                name="e_WayBillStatus}"
                                id="e_WayBillStatus}"
                                value={invoiceData?.e_WayBillStatus}
                                // onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                          </Row>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Generated Date"
                            name="generatedDate"
                            id="generatedDate"
                            type="date"
                            value={
                              invoiceData?.generatedDate || getTodaysData()
                            }
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Distance (KM)"
                            name="distance"
                            id="distance"
                            value={invoiceData?.distance}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Supply Type"
                            name="supplyType"
                            id="supplyType"
                            value={invoiceData?.supplyType}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transaction Type"
                            name="transactionType"
                            id="transactionType"
                            value={invoiceData?.transactionType}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Mode"
                            name="mode"
                            id="mode"
                            value={invoiceData?.mode}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            {invoiceData?.items &&
                            !!invoiceData?.items[0]?.loadingOtherTruckNo ? (
                              <InputField
                                className="inputBox"
                                label="Truck No"
                                name="loadingTruckNo"
                                id="loadingTruckNo"
                                value={
                                  invoiceData?.items
                                    ? invoiceData?.items[0]?.loadingOtherTruckNo
                                    : ""
                                }
                                onChange={onInputChange}
                                disabled={true}
                              />
                            ) : (
                              <InputField
                                className="inputBox"
                                label="Truck No"
                                name="loadingTruckNo"
                                id="loadingTruckNo"
                                value={
                                  invoiceData?.items
                                    ? invoiceData?.items[0]
                                        ?.loadingTruckNoDescription
                                    : ""
                                }
                                onChange={onInputChange}
                                disabled={true}
                              />
                            )}
                          </Col>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/* 01 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Address Details</span>
                  <span className="subHeaderTitle">Address details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Col xs={12} md={12} lg={12} className="p-2">
                        <p className="fw-bold mb-0">Company (From):</p>
                        <p className="fs-5 mb-0">
                          {invoiceData?.companyCodeDesc}
                        </p>
                        {/* <p className="fw-bold mb-0">Address:</p> */}
                        <p className="fs-5 mb-0">
                          {invoiceData?.companyAddress || "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={12} lg={12} className="p-2">
                        <p className="fw-bold mb-0">Dispatch (From):</p>
                        <p className="fs-5 mb-0">
                          {invoiceData?.items?.length > 0 &&
                          invoiceData?.items[0]?.godownAddress
                            ? invoiceData?.items[0]?.godownAddress
                            : ""}
                        </p>
                      </Col>
                      <Col xs={12} md={12} lg={12} className="p-2">
                        <p className="fw-bold mb-0"> Company (To):</p>
                        <p className="fs-5 mb-0">{invoiceData?.customerName}</p>
                        <p className="fs-5 mb-0">
                          {invoiceData?.items?.length > 0 &&
                          invoiceData?.items[0]?.customerAddress
                            ? invoiceData?.items[0]?.customerAddress
                            : ""}
                        </p>

                        {/* {invoiceData?.items?.length > 0 &&
                          invoiceData.items[0]?.certifications
                            ?.filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType?.includes(type)
                              )
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType; // Fallback to original if not found

                              return (
                                <p key={index} className="fs-5 mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })} */}
                      </Col>

                      <Col xs={12} md={12} lg={12} className="p-2">
                        <p className="fw-bold mb-0">Ship (To):</p>
                        <p className="fs-5 mb-0">
                          {invoiceData?.items?.length > 0
                            ? invoiceData?.items[0]?.shippingAddress + " "
                            : ""}
                          {invoiceData?.items?.length > 0
                            ? invoiceData?.items[0]?.shippingPostalCode
                            : ""}
                        </p>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/*02 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Goods Details</span>
                  <span className="subHeaderTitle">Goods details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <DataTable
                          title=""
                          columns={lineItemCol}
                          data={lineItemData}
                          // progressPending={orderSchedulingData?.status}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          // paginationTotalRows={orderSchedulingTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          // selectableRows
                        />
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/*04 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible4 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility4}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">E-Way Bill details</span>
                  <span className="subHeaderTitle">E-Way Bill details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible4 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Bags"
                            name="sumOfOrderQuantityLoad"
                            id="sumOfOrderQuantityLoad"
                            value={invoiceData?.totals?.totalBags}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total CGST"
                            name="totalCgst"
                            id="totalCgst"
                            value={invoiceData?.totals?.totalCgst}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total SGST"
                            name="totalSgst"
                            id="totalSgst"
                            value={invoiceData?.totals?.totalSgst}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {!viewInvoiceDataStatus && (
            <Row className="my-4 ">
              <Col
                lg={{ span: 2, offset: 8 }}
                className="d-flex justify-content-end mt-2"
              >
                <button className="btnTable btn-danger" onClick={handleCancel}>
                  Cancel
                </button>
              </Col>
              <Col lg={2} className="d-flex justify-content-end mt-2">
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disable}
                >
                  Save
                </button>
              </Col>
            </Row>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default EwayBillConfirmationModal;
